module.exports = __webpack_public_path__ + "img/bj_review.f3079eb3.png";